import { render, staticRenderFns } from "./SSelectCampaign.vue?vue&type=template&id=08829175"
import script from "./SSelectCampaign.vue?vue&type=script&lang=js"
export * from "./SSelectCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports